// Freedmont / Candi brand assets & names
export const BRAND = {
  shortName: "Candi",
  longName: "Candi — The Mortgage AI Assistant",
  tagline: "The Mortgage AI Assistant",
  company: "Freedmont Mortgage",
  logos: {
    horizontal: "https://customer-assets-39nsmqrw.emergentagent.net/job_mortgage-intel-3/artifacts/ck9fkb6e_logo-color.webp",
    stacked: "https://customer-assets-39nsmqrw.emergentagent.net/job_mortgage-intel-3/artifacts/hdrx5vfl_logo-stack-color.webp",
    mark: "https://customer-assets-39nsmqrw.emergentagent.net/job_mortgage-intel-3/artifacts/93qq69pi_logo-mark.png",
  },
};
